import React from "react";
import { Link } from "react-router-dom";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import "./HomeShortcut.css";

export const shouldShowHomeShortcut = (pathname, backTarget) =>
  Boolean(pathname && pathname !== "/" && backTarget && backTarget.split(/[?#]/)[0].replace(/\/$/, "") !== "");

export default function HomeShortcut({ language = "english" }) {
  const label = language === "arabic" ? "الرئيسية" : "Home";
  return <Link className="sf-home-shortcut" to="/" aria-label={label} title={label}>
    <HomeOutlinedIcon aria-hidden="true" /><span>{label}</span>
  </Link>;
}
